import { Button } from '@radix-ui/themes';
import { ContactSupportButton } from 'components/common/buttons/contact-support';
import { MachineUnavailableButton } from 'components/machine/buttons/unavailable';
import { MachineContext, MachineDialogMode } from 'contexts/machine.context';
import { CalibrateMode } from 'enums/calibration';
import { RADIX, RadixBtnSize } from 'lib_ts/enums/radix-ui';
import { useContext, useMemo } from 'react';
import useMachineStatusStore from 'stores/use-machine-status-store';

const TESTING_REALIGN = false;

interface IProps {
  /** applied to the button tag */
  className?: string;
  size?: RadixBtnSize;
}

export const MachineCalibrateButton = (props: IProps) => {
  const canCalibrate = useMachineStatusStore((s) => s.canCalibrate);

  const { calibrating, isActive, openDialog } = useContext(MachineContext);

  const mode = useMemo(() => {
    if (!isActive) {
      return CalibrateMode.Unavailable;
    }

    if (!canCalibrate) {
      return CalibrateMode.ContactSupport;
    }

    return CalibrateMode.Calibrate;
  }, [isActive, canCalibrate]);

  switch (mode) {
    case CalibrateMode.Unavailable: {
      if (TESTING_REALIGN) {
        return (
          <Button
            size={props.size}
            color={RADIX.COLOR.WARNING}
            className={props.className}
            onClick={() => openDialog(MachineDialogMode.Realign)}
          >
            Realign Machine
          </Button>
        );
      }

      return (
        <MachineUnavailableButton
          size={props.size}
          className={props.className}
        />
      );
    }

    case CalibrateMode.ContactSupport: {
      return (
        <ContactSupportButton size={props.size} className={props.className} />
      );
    }

    case CalibrateMode.Calibrate:
    default: {
      if (calibrating) {
        return (
          <Button
            size={props.size}
            color={RADIX.COLOR.WARNING}
            className={props.className}
            disabled
          >
            Realigning...
          </Button>
        );
      }

      return (
        <Button
          size={props.size}
          color={RADIX.COLOR.WARNING}
          className={props.className}
          onClick={() => openDialog(MachineDialogMode.Realign)}
        >
          Realign Machine
        </Button>
      );
    }
  }
};
